// @core/api/endpoints/audittrail/list_compliance_reports.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListComplianceReportsResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List compliance reports
 * Returns all compliance reports. Supports filtering by report type and status.
 */
export async function ListComplianceReports(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListComplianceReportsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/compliance-reports`;
  const requestOptions = options;
  return client.get<ListComplianceReportsResponse>(requestPath, { ...requestOptions, params });
}
